import type { Classroom } from "@monsterverse/island-types";

import MockClassrooms from "../api/mocks/getTeacherClassrooms.json";
import { mocksResponse } from "../utils/env";
import { UserManager } from "./UserManager";

export class TeacherManager {
  private static _instance: TeacherManager = new TeacherManager();
  static get instance(): TeacherManager {
    return this._instance;
  }

  private _classrooms: Classroom[] | undefined;

  async syncClassrooms(dataProvider: () => Promise<Classroom[]>) {
    if (!UserManager.instance.userId) {
      throw Error("Error syncing teacher classrooms for undefined user.");
    }
    if (mocksResponse()) {
      // return mocked reponse to avoid CORS errors in dev
      this._classrooms = MockClassrooms._items.map((c) => {
        const classOwner = c.collaborators?.find(
          (teacher): teacher is typeof teacher & { sharingStatus: "owner" } => teacher.sharingStatus === "owner"
        );

        return {
          _id: c._id,
          name: c.name,
          archived: c.archived,
          teacher: classOwner && {
            _id: classOwner._id ?? "",
            title: classOwner.title ?? "",
            firstName: classOwner.firstName ?? "",
            lastName: classOwner.lastName ?? "",
            avatarUrl: classOwner._links.photo.href,
          },
        };
      });
      return;
    }
    this._classrooms = await dataProvider();
  }

  get classes(): Classroom[] {
    return this._classrooms ?? [];
  }
  set classes(classes: Classroom[]) {
    this._classrooms = classes;
  }

  get sortedClasses(): Classroom[] {
    return this.classes.sort((a, b) => b._id.localeCompare(a._id));
  }
}
